// extracted by mini-css-extract-plugin
export default {"layout":"mainPage_layout__9amWa","userList":"mainPage_userList__6nZC8"};